import filter from "lodash/fp/filter";
import has from "lodash/fp/has";
import each from "lodash/fp/each";
import remove from "lodash/fp/remove";
import isNil from "lodash/fp/isNil";
import map from "lodash/fp/map";
import keys from "lodash/fp/keys";
import pickBy from "lodash/fp/pickBy";
import findIndex from "lodash/fp/findIndex";
import nth from "lodash/fp/nth";
import values from "lodash/fp/values";
import reduce from "lodash/fp/reduce";
import cloneDeep from "lodash/fp/cloneDeep";
import isEmpty from "lodash/fp/isEmpty";
import forOwn from "lodash/fp/forOwn";
import slice from "lodash/fp/slice";
import some from "lodash/fp/some";
class Controller {
  constructor($injector, Upload) {
    "ngInject";
    this.Upload = Upload;
    this.Events = $injector.get("Events");
    this.$injector = $injector;
  }

  $onInit() {
    this.isStepExpanded = true;
    this.isValidOnCheck = false;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;

    // Resource provided
    const hasResource = (step) => has("resource")(step);
    const hasresourcesExisted = filter(hasResource)(this.steps);
    if (hasresourcesExisted.length > 0) {
      const applyResourceMethod = async (step) => {
        const res = this.$injector.get(step.resource);
        // Don't apply on search resource method
        if (step.resourceMethod === "search") return;

        // When a resource method is not provided
        if (isNil(step.resourceMethod)) return;

        // When a resource options not provided
        if (isNil(step.resourceOption) || isNil(step.resourceParam)) {
          res[step.resourceMethod]();
          return;
        }

        // When a resource options provided
        const optionHandler = this.$injector.get(
          `${step.resourceOption}Handler`
        );
        const handler = optionHandler.get();
        if (isNil(handler)) {
          this.Events.emit(this.errorEvent, {
            message: `Please select ${step.resourceOption}!`,
          });
          return;
        }
        let paramValue = null;
        if (!isNil(handler)) paramValue = handler[step.resourceParam];
        const options = {
          [step.resourceOption.toLowerCase()]: paramValue,
          limit: 0,
        };
        const request = res[step.resourceMethod](options);
        const response = await request.$promise;
        step.resourceResult = response.hits;
      };
      Promise.all(map(applyResourceMethod)(hasresourcesExisted)).then(() => {
        each(this.initalizeStep.bind(this))(this.steps);
      });
    }
  }

  initalizeStep(step) {
    if (isNil(step.value)) return;
    switch (step.component) {
      case "select":
        this.stepperModel[step.name] = step.value;
        break;

      case "multi_select":
        if (!step.resourceResult) return;
        this.selected = step.resourceResult.reduce((acc, curr, indx) => {
          const exists = some((item) => item._id === curr._id, step.value);
          if (exists) {
            return {
              ...acc,
              [indx]: exists,
            };
          }
          return acc;
        }, {});
        if (step.conditional && step.conditional.value) {
          this.stepperModel[step.conditional.name] = step.conditional.value;
        }
        break;

      case "multi_dim_inputs": {
        this.stepperModel.checkedColumns = {};
        this.stepperModel[step.name] = this.stepperModel[step.name]
          ? {
              ...this.stepperModel[step.name],
            }
          : {};

        /**
         * Example stepperModel
         * stepperModel = {
         *  checkedColumns: {
         *     row-0: {
         *        col-1 : true
         *     },
         *     row-2: {
         *        col-0: true
         *     }
         *  }
         *  pricing : {
         *    row-0: {
         *      col-1: {
         *        ride_price: 150,
         *        captain_price: 100
         *      }
         *    }
         *  }
         * }
         */

        // Get selected step, Example: bustypes
        const multiDimStep = this.steps.find(
          (currstep) => currstep.name === step.connectedDefault
        );

        const selectedIds = multiDimStep.value.map((col) => col._id);
        // Multi-dimensional data
        if (multiDimStep && multiDimStep.value) {
          // 2 dimension
          if (multiDimStep.conditional.value) {
            // Get row values, Example: routes
            const rowstep = multiDimStep.conditional;

            const selectedRows = rowstep.value.map((row) => row._id);
            if (rowstep && rowstep.value) {
              // Loop on row values
              selectedRows.forEach((row) => {
                // Example step.value: subscriptions
                // Example rowValue: subscriptions of current route
                const rowValue = step.value[row];

                if (rowValue) {
                  this.stepperModel.checkedColumns[row] = {};
                  if (this.stepperModel[step.name][row]) {
                    this.stepperModel[step.name][row] = {
                      ...this.stepperModel[step.name][row],
                    };
                  } else {
                    this.stepperModel[step.name][row] = {};
                  }
                  // Loop on selected columns
                  selectedIds.forEach((column) => {
                    //
                    // Example colValue: subscription of the current bustype
                    const colValue = rowValue.find(
                      (item) => item[step.connectedDefaultKey]._id === column
                    );

                    if (colValue) {
                      // Set the row-column combination to true
                      this.stepperModel.checkedColumns[row][column] = true;
                      // Set the row-column combination values with options
                      this.stepperModel[step.name][row][column] = this
                        .stepperModel[step.name][row][column]
                        ? this.stepperModel[step.name][row][column]
                        : {};
                      step.options[this.stepperModel.type].forEach((option) => {
                        // Example: ride_price
                        if (colValue[step.name][option.name]) {
                          this.stepperModel[step.name][row][column][
                            option.name
                          ] = colValue[step.name][option.name];
                        }
                      });
                    }
                  });

                  // Filter based on the new selected from select step
                  const filteredModel = pickBy((colValue, colKey) => {
                    return selectedIds.includes(colKey);
                  })(this.stepperModel[step.name][row]);
                  this.stepperModel[step.name][row] = filteredModel;
                }
              });
            }
          } else {
            // 1 dimension
            // Loop on selected step
            multiDimStep.value.forEach((row) => {
              const rowId = row._id;
              if (row && rowId) {
                this.stepperModel[step.name][rowId] = this.stepperModel[
                  step.name
                ][rowId]
                  ? this.stepperModel[step.name][rowId]
                  : {};

                const rowValue = step.value.find(
                  (item) => item[step.connectedDefaultKey]._id === rowId
                );

                if (rowValue) {
                  step.options[this.stepperModel.type].forEach((option) => {
                    // Example: ride_price
                    if (rowValue[step.name][option.name]) {
                      this.stepperModel[step.name][rowId][option.name] =
                        rowValue[step.name][option.name];
                    }
                  });
                }
              }
            });
            // Filter based on the new selected from select step
            const filteredModel = pickBy((rowValue, rowKey) => {
              return selectedIds.includes(rowKey);
            })(this.stepperModel[step.name]);
            this.stepperModel[step.name] = filteredModel;
          }
        }
        break;
      }

      case "list_objects": {
        if (!isNil(step.value)) {
          this.stepperModel[step.name] = step.value.map((item) => ({
            ...item,
            isDisabled: false,
          }));
        }
        break;
      }
      case "date_picker":
        this.stepperModel[step.name] = step.value;
        break;

      default:
        break;
    }
  }

  toggleExpandStep() {
    this.isStepExpanded = !this.isStepExpanded;
  }

  toNext(step, index) {
    if (index + 1 > this.steps.length - 1) {
      return;
    }
    const isMultiSelectComponent = step.component === "multi_select";
    const currentStep = this.steps.find((s) => s.name === step.name);

    if (isNil(this.selected) && isMultiSelectComponent) {
      // Nothing selected yet
      this.stepperModel[step.name] = [];
    } else if (this.selected && isMultiSelectComponent) {
      const currentSelected = keys(
        pickBy((item) => item === true)(this.selected)
      );
      const currentData = step.resourceResult;
      this.stepperModel[step.name] = map((index) => {
        return nth(parseInt(index, 10))(currentData);
      })(currentSelected);
      currentStep.value = this.stepperModel[currentStep.name];
      if (currentStep.conditional) {
        currentStep.conditional.value = this.stepperModel[
          currentStep.conditional.name
        ];
      }
    }

    this.initalizeStep(this.steps[index + 1]);
    step.show = false;
    this.steps[index + 1].show = true;
  }

  toPrevious(step, index) {
    if (index - 1 < 0) {
      return;
    }
    step.show = false;
    this.steps[index - 1].show = true;
  }

  validateRequiredPredicate(items, step, isMultiDim) {
    const result = [];
    // Validation supported for only one step
    const required = filter((option) => option.required)(
      step.options[this.stepperModel.type]
    );

    const requiredColumnsPredicate = (acc2, curr2) => {
      const isAllRequiredValid = reduce((acc, curr) => {
        const currentValue = curr2[curr.name];
        if (Array.isArray(currentValue)) {
          return acc || isNil(currentValue) || isEmpty(currentValue);
        }
        return acc || isNil(currentValue);
      })(false)(required);
      return acc2 || isAllRequiredValid;
    };

    if (isMultiDim) {
      const forOwnWithKeys = forOwn.convert({ cap: false });
      forOwnWithKeys((value, key) => {
        const coresspondingCheckedValues = values(
          this.stepperModel.checkedColumns[key]
        );
        let isRequiredPassed = false;
        let mappedCheckedValues = {};
        if (!isNil(coresspondingCheckedValues)) {
          // On each row
          const toBeCheckedValues = slice(0)(coresspondingCheckedValues.length)(
            keys(value)
          );
          each((v) => {
            mappedCheckedValues = {
              ...mappedCheckedValues,
              [v]: value[v],
            };
          })(toBeCheckedValues);
          isRequiredPassed = reduce(requiredColumnsPredicate)(false)(
            mappedCheckedValues
          );
        }
        const isAllColumnsChecked =
          keys(mappedCheckedValues).length !==
          coresspondingCheckedValues.length;
        this.isValidOnCheck = isAllColumnsChecked ? this.isValidOnCheck : false;
        result.push(isRequiredPassed || isAllColumnsChecked);
      })(items);
      return reduce((acc, curr) => curr || acc)(false)(result);
    }

    return reduce(requiredColumnsPredicate)(false)(items);
  }

  changeCheckedState(value, row, col, step) {
    if (value && !step.value[row]) {
      step.value[row] = [];
    }

    if (step.value && step.value[row]) {
      const rowValue = step.value[row].find(
        (item) => item[step.connectedDefaultKey]._id === col
      );

      if (value && !rowValue) {
        step.value[row].push({
          [step.connectedDefaultKey]: { _id: col },
          pricing: {},
        });
        this.stepperModel[step.name][row][col] = {};
      }
    }

    if (has(`${row}.${col}`)(this.stepperModel.checkedColumns)) {
      const isChecked = this.stepperModel.checkedColumns[row][col];
      // If row has unchecked column delete this column
      if (!isChecked) {
        delete this.stepperModel.checkedColumns[row][col];
        delete this.stepperModel[step.name][row][col];
        step.value[row] = remove(
          (item) => item[step.connectedDefaultKey]._id === col
        )(step.value[row]);
      }
      // If row has all false columns delete the row as it will be empty
      if (isEmpty(this.stepperModel.checkedColumns[row])) {
        delete this.stepperModel.checkedColumns[row];
        delete step.value[row];
      }
    }

    const clonedItem = cloneDeep(this.stepperModel[step.name]);
    if (isNil(clonedItem)) return;
    if (!isNil(clonedItem) && !isNil(clonedItem[row])) {
      clonedItem[row] = {
        ...clonedItem[row],
        [col]: {},
      };
    }
    if (
      keys(clonedItem[row]).length ===
      keys(this.stepperModel.checkedColumns[row]).length
    ) {
      this.isValidOnCheck = this.validateRequiredPredicate(
        clonedItem,
        step,
        true
      );
    }
  }
  /*
    Validation logic:
    complex enough to not try to get anything from it!
    sorry ..
  */
  validateMultiDimInputs(step, item) {
    // Validate 1st dimension
    const connectedRow = this.stepperModel[step.connectedDefault];
    const connectedColumn = this.stepperModel[step.connectedSecond];
    const hasConnectedRow = !isNil(connectedRow) && connectedRow.length > 0;
    const hasConnectedColumn =
      !isNil(connectedColumn) && connectedColumn.length > 0;

    // Get checked columns
    const checkedColumns = isNil(this.stepperModel.checkedColumns)
      ? []
      : values(this.stepperModel.checkedColumns);

    let validateConnectedRows = false;
    let atLeastOneColumnChecked = false;
    const validateConnectedColumns = false;
    if (hasConnectedRow && !hasConnectedColumn) {
      validateConnectedRows =
        values(item)[step.connectedThrough] !==
        this.stepperModel[step.connectedDefault][step.connectedThrough];
    } else {
      atLeastOneColumnChecked =
        isNil(checkedColumns) || checkedColumns.length === 0;
    }

    return (
      isNil(values(item)) ||
      values(item).length === 0 ||
      validateConnectedRows ||
      validateConnectedColumns ||
      atLeastOneColumnChecked ||
      this.validateRequiredPredicate(item, step, hasConnectedColumn) ||
      this.isValidOnCheck
    );
  }

  validateMultiSelect(step) {
    const selectPredicate = (acc, curr) => {
      return acc && !curr;
    };
    const hasConditional = !isNil(step.conditional);
    let result = false;
    if (hasConditional && step.conditional.name) {
      const conditionalModel = this.stepperModel[step.conditional.name];
      const stepIndex = findIndex((f) => f.name === step.name)(this.steps);
      let sourceStep;
      if (stepIndex > 0) sourceStep = this.steps[stepIndex - 1].name;
      const meetsTarget =
        step.conditional.target === this.stepperModel[sourceStep];
      if (meetsTarget) {
        const conditionalExist =
          isNil(conditionalModel) || conditionalModel.length === 0;
        result =
          isNil(this.selected) ||
          reduce(selectPredicate)(true)(values(this.selected)) ||
          conditionalExist;
      } else {
        result =
          isNil(this.selected) ||
          reduce(selectPredicate)(true)(values(this.selected));
      }
    }

    return result;
  }

  validate(step) {
    let validator;
    if (isNil(this.stepperModel)) return false;
    const item = cloneDeep(this.stepperModel[step.name]);
    const stepComponent = step.component;
    switch (stepComponent) {
      /*
      Validate multi dimensional inputs:
      in the whole input table (1 dimensional or two dimensional (rows, and columns)),
      required inputs must be filled
    */
      case "multi_dim_inputs": {
        validator = this.validateMultiDimInputs(step, item);
        break;
      }

      /*
     Validate multi-select component: at least one item to be selected
     if the component has conditional component:
      validate the conditional component
    */
      case "multi_select": {
        validator = this.validateMultiSelect(step);
        break;
      }

      /*
      Validate input with unit component: value not nil, unit not nil
      or the object that has been computed also not nil
    */
      case "unit_input":
        validator =
          isNil(item) ||
          isNil(item[step.compute]) ||
          isNil(item[step.computeUnitName]);
        break;

      // Validate list-object component: required and list of length > 0
      case "list_objects":
        validator = step.required && (isNil(item) || item.length) === 0;
        break;
      case "document":
        validator = step.required && (!item || item.length === 0);
        break;
      default:
        validator = isNil(item);
        break;
    }
    return validator;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/stepper/stepper.controller.js